import { render, staticRenderFns } from "./CreditFile.vue?vue&type=template&id=f89c41e0&"
import script from "./CreditFile.vue?vue&type=script&lang=js&"
export * from "./CreditFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports